var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirdropIllustrationBig2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "311px",
    height: "228px",
    viewBox: "0 0 311 228",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "airdrop_illustration_big_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.68,25.83 C9.25,23.51 14.14,22.83 19.58,22.07 C26.64,21.07 35.23,21.84 39.21,14.75 C40.97,11.63 38.09,9.75 36.63,7.11 C34.97,4.11 34.11,3.65 33.05,0 C27.45,9.57 20.81,10.3 15.22,12 C10.27,13.48 5.38,14.56 0,19.1 L6.66,25.84 L6.68,25.83 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9014164,57.24 C27.9014164,51.88 22.4514164,45.54 16.3914164,38.5 C8.52141645,29.35 -3.88858355,20.25 1.18141645,8.29 C3.42141645,3.03 10.0014164,4.35 15.7114164,3.29 C22.2114164,2.12 24.0714164,2.58 30.7814164,0 C24.2214164,16.41 31.8914164,24.8 36.8414164,33 C41.2214164,40.24 46.0714164,47 46.5614164,57.89 L27.9714164,57.25 L27.9014164,57.24 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0627\\u66F4\\u65B0--\\u7EA2\\u5305airdrop-\\u9886\\u7EA2\\u5305-\\u5DF2\\u9886\\u5B8C",
    transform: "translate(-557.000000, -287.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(499.996798, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airdrop_illustration_big_2",
    transform: "translate(57.330275, 87.525222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.432927,187.493492 C244.042927,187.493492 310.192927,196.243492 310.192927,207.033492 C310.192927,217.823492 244.042927,226.583492 162.432927,226.583492 C80.8229268,226.583492 14.6729268,217.833492 14.6729268,207.033492 C14.6729268,196.233492 80.8229268,187.493492 162.432927,187.493492",
    id: "\\u8DEF\\u5F84",
    fill: "#444487"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 179.822927,
    y: 111.163492,
    width: 99.21,
    height: 91.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#C7C7FF",
    fillRule: "nonzero",
    x: 144.602927,
    y: 111.163492,
    width: 92.45,
    height: 91.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 79.7429268,
    y: 91.5634924,
    width: 100.25,
    height: 112.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#C7C7FF",
    fillRule: "nonzero",
    x: 44.1629268,
    y: 91.5634924,
    width: 93.42,
    height: 112.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#5050AA",
    fillRule: "nonzero",
    x: 178.172927,
    y: 150.903492,
    width: 64.32,
    height: 64.67
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF",
    points: "155.342927 150.903492 215.282927 150.903492 215.282927 215.573492 155.342927 215.573492"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-35",
    transform: "translate(256.002927, 165.348492) rotate(50.000000) translate(-256.002927, -165.348492) translate(210.072927, 136.893492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.64,32.42 C51.2,33.06 70.99,31.13 81.64,12.34 L71.25,2.93 C70.13,10.16 68.37,28.37 47.9,30.51 L48.64,32.42 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,31.46 C49.49,20.52 54.93,6.62 73.74,0.17 C76.7422406,3.97906898 79.3930832,8.05239653 81.66,12.34 C74.66,10.79 57.13,13.98 48.66,32.42 L47.12,31.46 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.26,28.35 L58.98,27.63 C63.31,28.72 76.36,26.44 83.08,16.55 L87.08,24.07 C82.32,28.54 75.47,33.07 59.27,28.35",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.13,27.83 L59.26,28.35 C70.99,24.09 75.43,22.23 87.16,24.12 L83.36,15.78 C73.89,16.23 70.24,18.96 58.11,27.83",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78,10.54 C18.24,17.21 19.48,22.75 24.58,25.54 C32.58,29.99 42.58,32.16 49.69,32.8 L50.17,31.8 C46.54,30.8 32.69,24.09 30.84,20.8 C28.3797055,16.6030945 28.1075772,11.4736631 30.11,7.04 L17.78,10.54 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.36,32.6 C51.19,20.68 40.65,4.89 25.82,0 L17.76,10.54 C25.76,11.3 47.64,19.89 49.67,32.85 L50.36,32.6 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#5050AA",
    fillRule: "nonzero",
    x: 22.66,
    y: 27.56,
    width: 69.2,
    height: 12.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.94,28.35 L35.22,27.63 C30.89,28.72 17.84,26.44 11.12,16.55 L7.12,24.07 C11.88,28.54 18.73,33.07 34.93,28.35",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.07,27.83 L34.94,28.35 C23.21,24.09 18.77,22.23 7.03,24.12 L10.82,15.78 C20.29,16.23 23.94,18.96 36.07,27.83",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7269EF",
    fillRule: "nonzero",
    x: 0,
    y: 27.56,
    width: 64.48,
    height: 12.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#40407F",
    fillRule: "nonzero",
    x: 2.28,
    y: 40.27,
    width: 59.93,
    height: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#40407F",
    fillRule: "nonzero",
    x: 62.21,
    y: 40.27,
    width: 27.21,
    height: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#40407F",
    fillRule: "nonzero",
    opacity: 0.26,
    x: 27.77,
    y: 40.27,
    width: 8.95,
    height: 2.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,27.56 C41.23,28.82 30.05,43.03 29.67,56.91 C27.86,55.8 18.3,48.06 17.18,47.39 C20.18,40.49 32.77,28.39 46.35,27.56 L48.9,27.56 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#40407F",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,27.56 C40.95,28.82 26.52,43.03 22.97,56.91 C21.41,55.8 13.62,48.06 12.65,47.39 C17.21,40.49 32.58,28.39 46.35,27.56 L48.9,27.56 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#474798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.15,27.56 C41.82,27.17 30.89,31.2 25.15,41.21 C22.47,40.74 17.69,39.81 15.41,39.21 C25.6,26.71 38.61,24.76 47.2,27.57",
    id: "\\u8DEF\\u5F84",
    fill: "#635BDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-34",
    transform: "translate(80.212927, 60.038492) rotate(-20.000000) translate(-80.212927, -60.038492) translate(8.622927, 22.203492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.62,35.21 C119.5,33.35 111.95,33.62 91.48,52.59 L94.39,55.8 L118.52,48.58 L123.52,41.06 L125.62,35.21 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(92.570000, 35.210000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#8282F4",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 40.97,
    height: 25.83
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.41,28.21 C30.57,23.58 39.28,44.94 52.41,46.96 L49.84,49.22 C49.84,49.22 32.92,46.73 32.3,46.51 C31.68,46.29 27.3,42.99 27.3,42.99 L24.41,28.21 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.81,43.41 L24.38,28.21 C27.14,38.53 45.38,48.44 50.75,48.62 L41.35,54.8 C35.7,54.61 21.1,50.7 17.81,43.41",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,3.77 C73.15,1.66 85.55,38.14 66.73,50.5 L73.73,51.84 C73.73,51.84 98.06,36.11 98.79,35.36 C99.52,34.61 102.52,26.77 102.52,26.77 L88.88,3.77 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,20.51 L88.88,3.77 C97.23,20.34 79.96,47.52 71.48,51.65 L94.4,53.59 C103.33,49.25 122.14,33.19 118.4,20.51",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54,0.03 C64.3,5.14 73.84,14.11 73.2,57.39 L64.68,57.39 L43.43,22.11 L47.81,8.54 L53.54,0.03 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(22.758584, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#8282F4",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: -3.88858355,
    y: 0.03,
    width: 50.45,
    height: 57.85
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 35.32,
    y: 49.84,
    width: 107.86,
    height: 22.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#C7C7FF",
    fillRule: "nonzero",
    x: 0,
    y: 49.84,
    width: 100.5,
    height: 22.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 3.54,
    y: 71.96,
    width: 93.42,
    height: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7269EF",
    fillRule: "nonzero",
    x: 96.96,
    y: 71.96,
    width: 42.41,
    height: 3.71
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.2029268,143.473492 C75.6354452,143.57978 71.842935,139.970634 71.7229268,135.403492 C71.6536408,134.623816 72.0237372,133.870312 72.6831353,133.448541 C73.3425334,133.02677 74.1817816,133.006741 74.8605497,133.396574 C75.5393178,133.786408 75.9449391,134.521398 75.9129268,135.303492 C76.0617414,137.490079 77.9076603,139.170742 80.0985812,139.114427 C82.2895022,139.058112 84.0466417,137.284837 84.0829268,135.093492 C84.1282012,133.98739 85.024351,133.106387 86.1310648,133.079974 C87.2377787,133.053561 88.1749368,133.890809 88.2729268,134.993492 C88.3792145,139.560974 84.7700686,143.353484 80.2029268,143.473492 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#ACACFC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3029268,142.973492 C94.7332995,143.085339 90.9374893,139.473052 90.8229268,134.903492 C90.7536408,134.123816 91.1237372,133.370312 91.7831353,132.948541 C92.4425334,132.52677 93.2817816,132.506741 93.9605497,132.896574 C94.6393178,133.286408 95.0449391,134.021398 95.0129268,134.803492 C95.1617414,136.990079 97.0076603,138.670742 99.1985812,138.614427 C101.389502,138.558112 103.146642,136.784837 103.182927,134.593492 C103.228201,133.48739 104.124351,132.606387 105.231065,132.579974 C106.337779,132.553561 107.274937,133.390809 107.372927,134.493492 C107.479215,139.060974 103.870069,142.853484 99.3029268,142.973492 L99.3029268,142.973492 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#ACACFC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4329268,148.753492 C65.2951235,148.722788 66.0883761,149.222537 66.4329268,150.013492 C70.9229268,160.413492 80.2329268,167.013492 90.1429268,166.733492 C100.052927,166.453492 108.662927,159.843492 112.792927,149.393492 C113.260533,148.383639 114.434741,147.913916 115.469827,148.322642 C116.504913,148.731369 117.041419,149.876604 116.692927,150.933492 C111.932927,162.933492 101.802927,170.633492 90.2429268,170.933492 C78.6829268,171.233492 67.7629268,163.663492 62.5829268,151.693492 C62.1227855,150.630328 62.6105095,149.395357 63.6729268,148.933492 C63.9119692,148.82413 64.170226,148.762964 64.4329268,148.753492 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#ACACFC",
    fillRule: "nonzero",
    transform: "translate(89.604320, 159.558766) scale(1, -1) translate(-89.604320, -159.558766) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdropIllustrationBig2);
export default __webpack_public_path__ + "static/media/airdrop_illustration_big_2.ecc06e3ca102638960170685ddf2632d.svg";
export { ForwardRef as ReactComponent };